/* eslint-disable sort-keys */
const LAYOUT_GRID = {
  MOBILE: {
    min: '0px',
    max: '430px',
    margin: '1.5rem',
    columns: 4,
    gutter: '1rem',
    containerMaxWidth: 'auto',
  },
  TABLET_PORTRAIT: {
    min: '431px',
    max: '745px',
    margin: '2rem',
    columns: 8,
    gutter: '1.5rem',
    containerMaxWidth: 'auto',
  },
  TABLET_LANDSCAPE: {
    min: '746px',
    max: '1239px',
    margin: '2rem',
    columns: 12,
    gutter: '1.5rem',
    containerMaxWidth: 'auto',
  },
  DESKTOP: {
    min: '1240px',
    max: '1439px',
    margin: 'auto',
    columns: 12,
    gutter: '1.5rem',
    containerMaxWidth: '1040px',
  },
  DESKTOP_LARGE: {
    min: '1440px',
    margin: 'auto',
    columns: 12,
    gutter: '1.5rem',
    containerMaxWidth: '1040px',
  },
}

const HTMLBOOK_BODY_MAX_WIDTH = {
  MEDIUM: '840px',
  LARGE: '1040px',
}
/* eslint-enable sort-keys */

const HTMLBOOK_FOOTER_HEIGHT = '40px'
const HTMLBOOK_NAVBAR_TOP_HEIGHT = '40px'

export { HTMLBOOK_BODY_MAX_WIDTH, HTMLBOOK_FOOTER_HEIGHT, HTMLBOOK_NAVBAR_TOP_HEIGHT, LAYOUT_GRID }
